import React, { useEffect, useState, Fragment } from 'react';
import { Pagination, PageHeader } from '../../../Common';
import { TableContent } from '../../Common/Table/tableContent';
import services from '../services';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import groupService from '../../Group/services';
import { FactorySchemaObject } from '../FactorySchema';
import { validateProperty, validate } from "../../Common"
import FormHelperText from '@material-ui/core/FormHelperText';
import Joi, { func } from '@hapi/joi'
import $ from 'jquery';
import authService from '../../Common/services';
import tokenService from '../../../Common/tokenDecoder';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import _, { forEach, set } from 'lodash';
import xlsx from 'json-as-xlsx';

const screenCode = 'FACTORY';

export function FactoryListing(props){
    const [factories, setFactories] = useState([]);
    const [groups, setGroups] = useState([]);
    const [csvData, setCsvData] = useState([]);
    const [searchFilter, setSearchFilter] = useState({
        groupID: 0
    });
    const [isTableHide, setIsTableHide] = useState(true);
    const [errors, setErrors] = useState({});
    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false
    });

    const contentRowNames = ["operationEntityCode", "operationEntityName", "isActive"];
    const csvHeaders = [
        { label: "Factory Code", value: "operationEntityCode" },
        { label: "Factory Name", value: "operationEntityName" },
    ];

    const schema = Joi.object(FactorySchemaObject).options({ allowUnknown: true });

    useEffect(() => {
        trackPromise(
            getPermissions()
        )
    }, []);

    useEffect(() => {
        trackPromise(
            handleSearch()
        )
    }, [searchFilter.groupID]);

    async function getGroupsForDropdown() {
        const groups = await groupService.getGroupsForDropdown();
        setGroups(groups);
    }

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWFACTORYLISTING');

        if(isAuthorized === undefined){
            props.history.push('/unauthorized');
        }

        var isAddEditEnabled = permissions.find(p => p.permissionCode == 'ADDEDITFACTORY');
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        setPermissions({
            ...permissionList,
            isAddEditEnabled: isAddEditEnabled !== undefined,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromToken();
        setSearchFilter({
            ...searchFilter,
            groupID: token.groupID
        });
        
        getGroupsForDropdown();
    }
    
    function destroyDataTable(){
        $('#example').DataTable().destroy();
    }

    function createDataTable(){
        $('#example').DataTable();
    }

    function handleClick(factory) {
        props.history.push({
            pathname: 'factories/addEdit',
            data: factory,
            edit: true
        })
    }

    function generateDropDownMenu(data) {

        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items
    }

    function handleChange(e) {
        
        const target = e.target
        const value = (target.name === 'isActive' || target.name === 'isErpEnabled') ? target.checked : target.value


        const error = { ...errors }
        const errorMessage = validateProperty(target, FactorySchemaObject)
        errorMessage ? error[target.name] = errorMessage : delete error[target.name]
        
        setSearchFilter({
            ...searchFilter,
            [e.target.name]: value
        });
     
        setErrors(error)
    }

    async function handleSearch() {

        const errorMessages = validate(schema, searchFilter);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({})
        if (errorMessages) return
    
        const response = await services.getFactoriesForDropdownByGroupID(searchFilter.groupID);
       
        if (response.data == null || response.data == undefined) {
            setIsTableHide(true)
        }
        else {
            setIsTableHide(false);
            destroyDataTable();
            setFactories(response.data);
            createDataTable();
            setCsvData();
        }
    }

    function createFile() {
        var settings = {
            sheetName: 'Factories',
            fileName: 'Factories_'+ groups[searchFilter.groupID],
            writeOptions: {}
        }

        var copyOfCsv = _.cloneDeep(factories)
        var newRow1 = {
            operationEntityCode: "Group :" + groups[factories[0]?.groupID]
        }
        var newRow2 = {
            operationEntityCode: "Generated date/time : " + new Date().toLocaleString(),
            operationEntityName: "Generated user : " + tokenService.getUserNameFromToken()
        }
        copyOfCsv.push({}, {}, newRow1)
        copyOfCsv.push({}, {},newRow2)
        xlsx(csvHeaders, copyOfCsv, settings, true)
    }
    
    return (
    <Fragment>
        <LoadingSpinerComponent/>
        <div className="row">
            <div className="col-md-12">
                    <div className="card">
                        <PageHeader
                            title="Factories"
                            isButtonEnable={permissionList.isAddEditEnabled}
                            buttonText="Add Factory"
                            path="factories/addEdit" />
                    <div className="card-body">
                       
                            <form onSubmit={handleSearch}>
                                <div className="form-group row">
                                    <div className="col-md-4 pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            value={searchFilter.groupID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                    </div>
                                </div>
                            </form>    
                       
                        <div className="table-responsive row-top-gap" hidden={isTableHide}>
                            <table id="example" className="display dataTable no-footer">
                                <thead>
                                    <tr>
                                        <th>Factory Code</th>
                                        <th>Factory Name</th>
                                        <th>Status</th>
                                        { permissionList.isAddEditEnabled ? <th>Actions</th> : null }
                                    </tr>
                                </thead>
                                <tbody>
                                    <TableContent
                                        data={factories}
                                        contentRowNames={contentRowNames}
                                        handleClick={handleClick} 
                                        hasEdit={permissionList.isAddEditEnabled}
                                    />
                                </tbody>
                            </table>
                            <div className="pt-2">
                                        <input
                                            type="button"
                                            className="btn btn-primary pull-right ml-2"
                                            value="Excel"
                                            onClick={createFile}
                                        />
                                    </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Fragment>
    );
}


